import { makeStyles } from "@saleor/macaw-ui";

const useMyTypographyStyle = makeStyles(
  () => ({
    h7: {
      fontWeight: 400,
      fontSize: "2rem",
      lineHeight: "26px"
    },
    body3: {
      fontWeight: 400,
      fontSize: "1.4rem",
      lineHeight: "22px"
    },
    subtitle3: {
      fontWeight: 700,
      fontSize: "1.4rem",
      lineHeight: "22px"
    },
    button2: {
      fontWeight: 700,
      fontSize: "1.6rem",
      lineHeight: "24px"
    },
    button3: {
      fontWeight: 700,
      fontSize: "1.4rem",
      lineHeight: "22px"
    },
    caption: {
      fontWeight: 400,
      fontSize: "1.2rem"
    },
    body2: {
      fontSize: "1.6rem",
      fontWeight: 400
    },
    captionBold: {
      fontWeight: 700,
      fontSize: "1.2rem",
      lineHeight: "18px"
    }
  }),
  { name: "myTypography" }
);

export default useMyTypographyStyle;
